<template>
    <div class="topBox">
      <div class="header_con">
        <div class="logo_title">
          <img src="../../../static/qlrtu_query/img.png" alt="">
          <div class="text_box">
            <div class="text2">{{title}}</div>
          </div>
        </div>


      </div>
    </div>



</template>

<script>
import axios from 'axios'
import {logIns} from "../../patentAgentExam/api";
import {mapState} from "vuex";

export default {
  name: 'headers',
  props:['title'],
  data () {
    return {

    }
  },


  created() {


  },
  methods: {


  }

}
</script>
<style lang="less" scoped>

  .topBox{
    width: 100%;
    height: 7.375rem;
    background: rgb(27, 61, 109);
    color: #ffffff;
    display: grid;
    place-items: center;
    width: 100%;
    .header_con{
      width: 75rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;


      .logo_title{
        height:4.875rem;
        display: flex;
        justify-content: flex-start;
        img{
          width: 3.3125rem;
        }
        .text_box{
          //width:40rem ;
          //background: #57a3f3;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          padding-left: 1.25rem;
          .text2{
            font-weight: 700;
            font-size: 1.75rem;
          }
        }
      }

    }

  }




</style>





// WEBPACK FOOTER //
// src/comm/components/headers2.vue